export enum AccModeEnum {
    NONE = 0,
    ACC_OLD = 1,
    ACC_NEW = 2
}
